function normalizeHospitals(hospitals = []) {
  return hospitals
    .map(({ value, pepId }) => ({ value, pepId: pepId || '' }))
    .sort((a, b) => a.value.localeCompare(b.value));
}

function normalizeString(value) {
  return value || '';
}

function getRoleValue(roleState) {
  const { value } = roleState || {};
  if (value && typeof value === 'object') return value.value || '';
  return value || '';
}

function getProfessionalBoardValue(professionalBoardState) {
  const { value } = professionalBoardState || {};
  if (value && typeof value === 'object') return value.value || '';
  return value || '';
}

export function buildFormSnapshot({
  fullName,
  username,
  userPosition,
  phoneNumber,
  email,
  proxyEmailAdmin,
  roleOrchestra,
  roleDiva,
  userHospitals,
  professionalBoard,
  boardRegistration,
  isSystemUser,
}) {
  return JSON.stringify({
    fullName: normalizeString(fullName),
    username: normalizeString(username),
    userPosition: normalizeString(userPosition),
    phoneNumber: normalizeString(phoneNumber),
    email: normalizeString(email),
    proxyEmailAdmin: proxyEmailAdmin || null,
    roleOrchestra: normalizeString(roleOrchestra),
    roleDiva: normalizeString(roleDiva),
    userHospitals: normalizeHospitals(userHospitals),
    professionalBoard: normalizeString(professionalBoard),
    boardRegistration: normalizeString(boardRegistration),
    isSystemUser: Boolean(isSystemUser),
  });
}

export function buildFormSnapshotFromUser(user) {
  return buildFormSnapshot({
    fullName: user.fullName,
    username: user.username,
    userPosition: user.userPosition,
    phoneNumber: user.phoneNumber,
    email: user.email,
    proxyEmailAdmin: user.proxyEmailAdmin,
    roleOrchestra: user.roleOrchestra,
    roleDiva: user.roleDiva,
    userHospitals: user.userHospitals,
    professionalBoard: user.professionalBoard,
    boardRegistration: user.boardRegistration,
    isSystemUser: user.isSystemUser,
  });
}

export function buildEmptyFormSnapshot() {
  return buildFormSnapshot({});
}

export function isFormSyncedWithUser(user, formState) {
  if (!user) return true;

  const {
    userName,
    email,
    proxyEmailAdmin,
  } = formState;

  if (userName.value !== user.username) return false;
  if ((email.value || '') !== (user.email || '')) return false;
  if ((proxyEmailAdmin || null) !== (user.proxyEmailAdmin || null)) return false;

  return true;
}

export function buildFormSnapshotFromState({
  fullName,
  userName,
  userPosition,
  phoneNumber,
  email,
  proxyEmailAdmin,
  roleOrchestra,
  roleDiva,
  userHospitals,
  professionalBoard,
  boardRegistration,
  isSysUser,
}) {
  return buildFormSnapshot({
    fullName: fullName.value,
    username: userName.value,
    userPosition: userPosition.value,
    phoneNumber: phoneNumber.value,
    email: email.value,
    proxyEmailAdmin,
    roleOrchestra: getRoleValue(roleOrchestra),
    roleDiva: getRoleValue(roleDiva),
    userHospitals: userHospitals.value,
    professionalBoard: getProfessionalBoardValue(professionalBoard),
    boardRegistration: boardRegistration.value,
    isSystemUser: isSysUser,
  });
}
